export const getStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const removeStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const setStorage = (key: string, val: any) => {
  localStorage.setItem(key, val);
};
